"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenGrantType = exports.AuthEndpoints = exports.AccessTokenError = void 0;
var AuthEndpoints;
(function (AuthEndpoints) {
    AuthEndpoints["GetAccessToken"] = "/oauth/token";
})(AuthEndpoints || (exports.AuthEndpoints = AuthEndpoints = {}));
var TokenGrantType;
(function (TokenGrantType) {
    TokenGrantType["Password"] = "password";
    TokenGrantType["Mfa"] = "mfa";
    TokenGrantType["Partner"] = "partner";
    TokenGrantType["RefreshToken"] = "refresh_token";
})(TokenGrantType || (exports.TokenGrantType = TokenGrantType = {}));
var AccessTokenError;
(function (AccessTokenError) {
    AccessTokenError["InvalidGrant"] = "invalid_grant";
    AccessTokenError["MfaRequired"] = "mfa_required";
    AccessTokenError["UserInactive"] = "user_inactive";
})(AccessTokenError || (exports.AccessTokenError = AccessTokenError = {}));
